<template>
  <div>
    <div class="text-h6 mt-2 mb-4">
      État du Routeur
    </div>

    <v-row v-if="telemetry && telemetry.transport">
      <v-col cols="6">
        <router-mobile-relays :telemetry="telemetry"></router-mobile-relays>
        <router-residential-relays :telemetry="telemetry"></router-residential-relays>
      </v-col>
      <v-col cols="6">
        <h4>Métriques (5s avg)</h4>

        <v-data-table
          :headers="metrics.headers"
          :items="metricsItems"
          :items-per-page="100"
          sort-by="key"
          dense
        ></v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RouterMobileRelays from './AdminMultiProxyRouter/RouterMobileRelays'
import RouterResidentialRelays from './AdminMultiProxyRouter/RouterResidentialRelays'

export default {
  name: 'AdminMultiProxyRouterPage',
  components: { RouterResidentialRelays, RouterMobileRelays },
  data () {
    return {
      loading: true,
      telemetry: {},
      interval1: null,
      metrics: {
        headers: [
          { text: 'Name', value: 'key' },
          { text: 'Value', value: 'value' },
        ]
      }
    }
  },
  computed: {
    metricsItems () {
      const items = []
      if (this.telemetry && this.telemetry.metrics) {
        for (const [key, value] of Object.entries(this.telemetry.metrics)) {
          items.push({ key, value })
        }
      }
      return items
    }
  },
  methods: {
    async refreshTelemetry () {
      await this.$api.get('/multi-proxy/router/telemetry', null, { silent: true })
        .then(response => {
          this.loading = false
          this.telemetry = response.data
        })
    },
  },
  mounted () {
    this.refreshTelemetry()
    this.interval1 = setInterval(() => this.refreshTelemetry(), 5000)
  },
  beforeDestroy () {
    clearInterval(this.interval1)
  }
}
</script>